<template>
  <v-main class="pa-0" align-content="center">
    <div class="mx-10">編集・削除したいタイルをクリックしてください。</div>
    <v-card v-if="wss&&wss.length">
      <v-tabs
        v-model="tab"
        align-with-title
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="ws in wss"
          :key="'folder'+ws.id"
        >
          {{ ws.title }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="ws in wss"
          :key="'folder'+ws.id"
        >
          <v-card class="pa-4">
            <tile :key="ws.id+'tile'" :wsId="ws.id" inSetting tileEnabled />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-card v-else class="pa-4">
      <tile inSetting tileEnabled />
    </v-card>
  </v-main>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";
import tile from "../tile.vue";
import Vue from 'vue'
import Toasted from "vue-toasted";
Vue.use(Toasted,{iconPack : 'material'})
export default {
  data() {
    return {
      db: firebase.firestore(),
      mylid: [],
      tab: 0,
    };
  },
  mounted() {
    // 初期のタブ位置を設定
    const id = this.$route.params.id;
    if (id) {
      const index = this.wss.findIndex((el) => el.id === id);
      if (index !== -1) {
        this.tab = index;
      }
    }
  },
  components: {
    tile,
  },
  computed: {
    navlid() {
      return this.$store.getters.navlid;
    },
    wss() {
      return this.$store.getters.wss;
    },
    numlid() {
      return this.mylid.length;
    },
  },
  methods: {
    showToast(message="完了しました"){
      this.$toasted.success(message, {
        theme: "bubble",
        position: "top-center",
        duration : 5000,
      });
    },
  },
};
</script>
